/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { ServerConfig } from '@/types/app-config';

const config: ServerConfig = {
  apiBaseUrl: 'http://asmayoral.dominiomayoral.es:10188',
  graphql: {
    introspection: false,
    playground: false,
  },
};

export default config;
